export const defaultPanelsDynamicProfile = {
  name: '',
  sunset_switch_on_threshold: 100,
  sunrise_switch_on_threshold: 100,
  description: ''
}